// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/bgGlobal.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.s30sR8IH {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-blend-mode: difference;
  background-color: white;
  height: 100%;
}
.NEsW6mwl:hover {
  background-color: rgba(37, 89, 149, 1);
}
.NEsW6mwl span {
  font-weight: bold;
  font-size: 1.3rem;
  color: rgba(241, 142, 28, 1);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menuList": `s30sR8IH`,
	"menuListItem": `NEsW6mwl`
};
export default ___CSS_LOADER_EXPORT___;
